import axios from "../axios";

export const getCountries = async () => {
  try {
    const response = await axios.get(`/countries`);
    return response.data.data.items;
  } catch (err) {
    throw new Error(err + " Failed to fetch network countries");
  }
};
